// removed by extract-text-webpack-plugin
module.exports = {"photo":"photo_2kIiW","inner":"inner_1h_7_","moments":"moments_32RS1","image":"image_EHJ7R","pickedFill":"pickedFill_3Rtg9"};


//////////////////
// WEBPACK FOOTER
// ./app/components/favorite-picker-photo/styles.scss
// module id = 430
// module chunks = 1